import instObj from '@/backend/axios-instances'

const resource = "/orders/details"
const instance = instObj.baseInstance

export default {
  get(parameters) {
    return instance.get(resource, { params: parameters });
  },
  post(data, parameters) {
    // need order_id in body
    return instance.post(resource, data, { params: parameters });
  }
}
